import * as React from "react";

function CheckCircleForModalSVG(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path fill="none" d="M55 27.7001V30.0001C54.9969 35.3912 53.2513 40.6368 50.0233 44.9547C46.7954 49.2726 42.2582 52.4313 37.0884 53.9599C31.9186 55.4885 26.3931 55.3049 21.3362 53.4366C16.2792 51.5683 11.9616 48.1154 9.0274 43.5928C6.09317 39.0702 4.69948 33.7203 5.05419 28.3409C5.40891 22.9616 7.49302 17.841 10.9957 13.7428C14.4984 9.6447 19.232 6.78861 24.4905 5.60051C29.749 4.41242 35.2507 4.95599 40.175 7.15015"  stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
<path fill="none" d="M55 10L30 35.025L22.5 27.525" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  );
}

const MemoCheckCircleForModalSVG = React.memo(CheckCircleForModalSVG);
export default MemoCheckCircleForModalSVG;
